export default class AlreadyInUseError extends Error {}
